export default {"src":"/_next/static/media/SingleDryCell.daae1c91.svg","height":794,"width":1123,"blurWidth":0,"blurHeight":0};